<template>
	<div class="tologinbox">
		<van-popup v-model:show="loginConfig.show" style="--van-popup-background:transparent;">
			<div class="loginbox" id="loginguidancebox" :dataShow="loginConfig.show">
				<img class="bannerimg" loading="lazy" :src="loginData.advertImageUrl" @error="imageError(loginData,'advertImageUrl','/img/login_banner.png')" />
				<div class="title">{{ loginData.title || '边看边聊，高清直播' }}</div>
				<img class="toimg" loading="lazy" :src="getExt('/img/login_to.png')" @click.stop="toLoginFn" />
				<img class="closeimg" loading="lazy" :src="getExt('/img/login_close.png')" @click.stop="closeLoginFn" />
			</div>
		</van-popup>
	</div>
</template>

<script setup>
import { ref, reactive, getCurrentInstance, onMounted, onDeactivated } from 'vue';
let {proxy} = getCurrentInstance();
let advertData = reactive([]);
let loginData = reactive({
	advertImageUrl: '',
	title: '',
});
let loginConfig = reactive({
	show: false,
	type: '',
});

onMounted(()=>{
	// 预加载登录弹窗图片
	const bannerImg = new Image();
	bannerImg.onload = () => {
		loginData.advertImageUrl = bannerImg.src;
	};

	let StartUp = localStorage.getItem('qx2StartUp');
	if (StartUp) {
		advertData.length = 0;
		StartUp = JSON.parse(StartUp);
		if (StartUp?.advertData) {
			advertData.push(...StartUp.advertData);
			let nowTimestamp = new Date().getTime();
			let adlist = advertData.filter(a=>a.nativeType=="4" && a.startTimestamp <= nowTimestamp && a.endTimestamp >= nowTimestamp).sort((a,b)=>a.startTimestamp-b.startTimestamp);
			if (adlist.length>0) {
				Object.assign(loginData, adlist[0]);
			}
			// 设置图片源（会从缓存中加载）
			bannerImg.src = loginData.advertImageUrl;			
		}
	}
	proxy.mitter.on('triggerLogin', (data)=>{
		let { show, type } = data;
		Object.assign(loginConfig, data);
	});
})
let toLoginFn = ()=>{
	let redirectUrl = proxy.$route.path;
	let query = {redirectUrl};
	let hasquery = Object.keys(proxy.$route.query).length>0;
	if (hasquery) {
		Object.assign(query, {redirectQuery: encodeURIComponent(JSON.stringify(proxy.$route.query)) });
	}
	if(proxy.constant.Source==4){
		 // App 内打开 — 将参数拼接到 URL 上传给原生层
		let uriValue = `/personal_login`;
		proxy.openAppViewToNewPage(uriValue);
	}else{
		proxy.routerRreplace({path:'/personal_login', query });
	}
	loginConfig.show = false;
	if (loginConfig.type=='loginguidance') {
		proxy.mitter.emit('loginguidanceAddVisitRecord', {actionType:'AdClient'});
	}
}
let closeLoginFn = ()=>{
	loginConfig.show = false;
	if (loginConfig.type=='loginguidance') {
		proxy.mitter.emit('loginguidanceAddVisitRecord', {actionType:'AdClose'});
	}
}

onDeactivated(()=>{
	proxy.clearObject(loginConfig);
})


</script>

<style lang="less" scoped>
.tologinbox{
	.loginbox{
		display: flex;
		flex-direction: column;
		align-items: center;
		.bannerimg{
			width: 307px;
			height: fit-content;
    		object-fit: contain;
		}
		.title{
			// font-family: YouSheBiaoTiHei;
			font-weight: 400;
			font-size: 41px;
			color: #FFFFFF;
			margin: 3px 0 18px;
			white-space: nowrap;
		}
		.toimg{
			width: 163px;
			height: 38px;
		}
		.closeimg{
			width: 39px;
			height: 39px;
			margin-top: 30px;
		}
	}
}

</style>